import React, { Component } from 'react'
import content from '../content'
import Ramp from '../ramp'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import './rendering.css'
import s from './slide.css'

const animationTime = parseInt(s.animationTime)

const renderingMaskUrl = `${process.env.PUBLIC_URL}/images/WilshireGrand.png`
const renderingUrl = `${process.env.PUBLIC_URL}/images/InvertContentMask.png`

class Rendering extends Component {
  constructor(props) {
    super(props)
    this.state = {
      revealMask: false,
      revealShader: false,
    }
  }

  componentDidMount() {
    setTimeout(() => this.setState({ revealMask: true }), 100)
    setTimeout(() => this.setState({ revealShader: true }), 200)
  }

  render() {
    const { selectedContent } = this.props
    const content =
      typeof selectedContent.r === 'number'
        ? {
            name: `${selectedContent.r} ${selectedContent.g} ${
              selectedContent.b
            } ${selectedContent.a}`,
            gradient: {
              scale: 1,
              speed: 0.01,
              rotation: 90,
              stops: [
                [
                  [
                    selectedContent.r / 255,
                    selectedContent.g / 255,
                    selectedContent.b / 255,
                  ],
                  0.0,
                ],
                [
                  [
                    selectedContent.r / 255,
                    selectedContent.g / 255,
                    selectedContent.b / 255,
                  ],
                  1.0,
                ],
              ],
            },
            wave: {
              enabled: false,
            },
            sparkle: {
              enabled: false,
            },
          }
        : selectedContent
    console.log(content.name)
    if (content) {
      return (
        <div
          className="rendering"
          style={{ opacity: this.state.revealMask ? 1 : 0 }}
        >
          <div className="shader-with-building-mask">
            <img
              src={renderingMaskUrl}
              style={{
                height: '600px',
                zIndex: 2,
                position: 'absolute',
                right: '0px',
                top: '13px',
                transform: 'scale(0.8) translate3d(0,0,0)',
                opacity: 0.3,
              }}
            />
            <img
              src={renderingUrl}
              style={{
                height: '600px',
                zIndex: 1,
                position: 'absolute',
                right: '0px',
                top: '13px',
                transform: 'scale(0.8) translate3d(0,0,0)',
              }}
            />
            <div
              className="shader-container"
              style={{ opacity: this.state.revealShader ? 1 : 0 }}
            >
              <ReactCSSTransitionGroup
                transitionName={`slide-${this.props.slide}`}
                transitionEnterTimeout={animationTime}
                transitionLeaveTimeout={animationTime}
              >
                <Ramp key={content.name} content={content} />
              </ReactCSSTransitionGroup>
            </div>
          </div>
        </div>
      )
    } else {
      return <div />
    }
  }
}

export default Rendering



// WEBPACK FOOTER //
// ./src/components/rendering/index.js